import React, { useCallback } from "react";
import { IconContainer } from "./elements/IconContainer";
import { ReactComponent as SafeIcon } from "../../../../img/approval_svgs/Safe.svg";
import { Text } from "../../../general/Text";
import { css } from "@emotion/react";
import SignatureRequest from "./SignatureRequest";
import { NAV_LINKS } from "../../../../config/consts";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { ApprovalStore } from "../../../../store/approvals/ApprovalsStore";
import { useApprovalTarget } from "../../../../hooks/allowances/useApprovalTarget";
import { FlexContainer } from "../../../../containers/FlexContainer";
import { ApprovalsHeader } from "./elements/ApprovalsHeader";
import { Link } from "react-router-dom";
import { SplashScreenContainer } from "./ApprovalsSplashScreen";

export interface EnableSpendingProps {
  onDone: () => void;
}
export const EnableSpending: React.FC<EnableSpendingProps> = props => {
  const { theme } = GlobalStore.getRawState();
  const permitType = ApprovalStore.useState(s => s.permitType);
  const approvalTarget = useApprovalTarget();

  const handleClose = useCallback(() => {
    props.onDone();
  }, [props]);

  return (
    <SplashScreenContainer>
      <ApprovalsHeader />
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          margin-top: 12px;
          flex: 1 0 0;
          align-self: stretch;
        `}
      >
        <IconContainer>
          <SafeIcon width={130} height={130} />
        </IconContainer>
        <FlexContainer
          css={css`
            display: flex;
            padding: 14px 24px;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 15px;
            flex: 1 0 0;
            align-self: stretch;
          `}
        >
          <Text
            shouldScale={false}
            textStyle="Title"
            size="Large"
            textCss={css`
              text-align: center;
              max-width: 250px;
            `}
          >
            Enable spending
          </Text>
          <Text
            textStyle={"Paragraph"}
            size={"Large"}
            color={theme.font.secondary.hover}
            textCss={css`
              text-align: center;
            `}
          >
            Grant permission in your wallet to securely trade your tokens.{" "}
            <Link
              to={NAV_LINKS.DOCUMENTATION_MANAGE_PERMISSIONS}
              target="_blank"
              rel="nofollow noreferrer"
              css={css`
                text-decoration: none;
              `}
            >
              <Text
                textStyle={"Paragraph"}
                size={"Large"}
                color={theme.button.tertiary.text.default}
                textCss={css`
                  display: inline-block;
                `}
              >
                Learn more...
              </Text>
            </Link>
          </Text>
        </FlexContainer>
      </div>
      <SignatureRequest
        permitType={permitType}
        approvalTarget={approvalTarget}
        onSignatureDone={handleClose}
      />
    </SplashScreenContainer>
  );
};
